<template>
  <v-container fluid>
    <v-row>
      <v-col sm="6">
        <h3 class="subtitle-1">Available Vouchers</h3>
        <v-data-table
          :items="vouchers"
          :headers="vouchersHeaders"
          v-model="selectedVouchers"
          single-select
          show-select
        ></v-data-table>
        <v-row justify="center">
          <v-btn
            color="blue-grey"
            class="white--text mt-2"
            :loading="loading"
            @click="onGenerate"
            :disabled="
              selectedSuppliers.length == 0 || selectedVouchers.length == 0
            "
          >
            Generate
            <v-icon right dark>mdi-cloud-upload</v-icon>
          </v-btn>
        </v-row>
      </v-col>
      <v-col sm="6">
        <h3 class="subtitle-1">Suppliers</h3>
        <v-data-table
          :items="suppliers"
          :headers="suppliersHeaders"
          v-model="selectedSuppliers"
          show-select
        ></v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <code>{{ itinerary }}</code>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../helpers";
import { TASK_STATUS_QUERY } from "../../../constants/graphql";

const AVAIL_DOCS = gql`
  query availableDocs {
    availableDocuments {
      edges {
        node {
          id
          name
          type
        }
      }
    }
  }
`;
const GENERATE_VOUCHERS_MUTATION = gql`
  mutation generateVouchers($itineraryId: ID!, $documentTypeId: ID!, $suppliers: [ID!]) {
    generateDocument(
      itineraryId: $itineraryId
      documentTypeId: $documentTypeId
      suppliers: $suppliers
    ) {
      id
      status
    }
  }
`;
export default {
  name: "itinerary-details-vouchers",

  props: {
    itinerary: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      debug: false,
      loading: false,
      vouchersHeaders: [
        { text: "Name", value: "name" },
        {
          text: "Actions",
          value: "",
          sortable: false,
          align: "right",
        },
      ],
      suppliersHeaders: [{ text: "Name", value: "name" }],
      selectedSuppliers: [],
      selectedVouchers: [],
      taskId: null,
      checkStatus: false,
    };
  },

  computed: {
    vouchers() {
      return this.availableDocuments && this.availableDocuments.edges
        ? this.availableDocuments.edges
            .map(removeGQLTypename)
            .filter((ad) => ad.type == "V")
        : [];
    },
    suppliers() {
      if (this.itinerary && this.itinerary.items) {
        const suppliers = this.itinerary.items.edges
          .map(removeGQLTypename)
          .filter((item) => !!item.supplier) //https://tracker.globetrack.ie/issues/6823
          .filter(
            (item) =>
              item.status.toString().toUpperCase().indexOf("CANCEL") === -1 &&
              !item.supplier.noVoucher &&
              !item.service.noVoucher
          ) //https://tracker.globetrack.ie/issues/6868 and https://tracker.globetrack.ie/issues/9022
          .map((item) => ({ name: item.supplierName, id: item.supplier.id }));
        return Array.from(new Set(suppliers.map((s) => s.id))).map((id) => {
          return suppliers.find((s) => s.id == id);
        });
      } else {
        return [];
      }
    },
  },

  methods: {
    onGenerate() {
      this.$apollo
        .mutate({
          mutation: GENERATE_VOUCHERS_MUTATION,
          variables: {
            itineraryId: this.itinerary.id,
            documentTypeId: this.selectedVouchers[0].id,
            suppliers: this.selectedSuppliers.map((s) => s.id),
          },
        })
        .then(this.generateDocHandler, this.generateDocErrHandler);
    },
    generateDocErrHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error",
      });
      this.emit("error", err.graphQLErrors[0].message);
    },
    generateDocHandler(result) {
      this.loading = true;
      this.taskId = result.data.generateDocument.id;
      this.checkStatus = true;
    },
  },

  apollo: {
    availableDocuments: {
      query: AVAIL_DOCS,
    },
    taskStatus: {
      query: TASK_STATUS_QUERY,
      variables() {
        return { taskId: this.taskId };
      },
      result({ data }) {
        this.checkStatus = false;
        if (data.taskStatus.status == "IN_PROGRESS") {
          setTimeout(() => {
            this.checkStatus = true;
          }, 2000);
        } else {
          this.loading = false;
          this.$store.dispatch("showAppSnackbar", {
            msg: `Document "${this.selectedVouchers[0].name}" is ready`,
          });
        }
        //console.log('status',data.generateDocumentStatus.status);
      },
      skip() {
        return !this.checkStatus;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsVouchers.vue